import _ from 'lodash';
import store from '../utils/store';
import apiService from '@dishopsaas/dishop-backend-api-service'
import { getShopId, getIdToken } from './firebase'

import {
  API_CREATE_PROMOTION,
  SUITABLE_TECHS,
  BUSINESS_TYPE_CODE,
  API_SYNCHRONIZE_MENU,
  API_UPDATE_PROMO,
  ZELTY
} from '../constants';
import { sendPostRequest, sendPutRequest } from './backend';
import { checkAccess, getUserPermissions } from '../utils/admins';
import { updateOrderTypes } from '../utils/shopUtils';
import { hasExternalIntegration } from 'src/utils/externalIntegration';

export { getShopId } from './firebase' // just an alias

export const updateCollection = async (driverId, espece, cb, ticket_resto) => {
  try {
    const paymentValues = {
      cash: parseFloat(espece),
      cb: parseFloat(cb),
      ticket_resto: parseFloat(ticket_resto),
    }
    await apiService.driversUpsert([driverId], paymentValues);

  } catch (err) {
    console.error(err); // Gérer les erreurs de manière appropriée
    throw err
  }
};





export const addPromo = async (promotion) => {
  const idToken = await getIdToken();
  const { shops = {} } = store.getState().firebaseRealTime;
  const { isGeneralData } = promotion
  const hasAccess = checkAccess('features', 'globalCodePromo')

  if (hasAccess && isGeneralData && shops) {
    for (const key of _.keys(shops)) {
      sendPostRequest(
        API_CREATE_PROMOTION,
        { shopId: key, promotion },
        { Authorization: `Bearer ${idToken}` }
      );
    }
  } else {
    await sendPostRequest(
      API_CREATE_PROMOTION,
      { shopId: getShopId(), promotion },
      { Authorization: `Bearer ${idToken}` }
    );
  }
};

export const removePromo = async (key, activation, promotions) => {
  const { shops = {} } = store.getState().firebaseRealTime;
  const { isGeneralData } = promotions[key];

  if (checkAccess('features', 'modifyGlobalPromo') && isGeneralData) {
    if (shops) {
      for (const shopId in shops) {
        await apiService.shopsUpsert([shopId, 'promotions', key], { expired: !activation })
      }
    }
  } else {
    await apiService.shopsUpsert([getShopId(), 'promotions', key], { expired: !activation })
  }
}
export const updatePromo = async (promotion) => {
  const idToken = await getIdToken();
  const { shops = {} } = store.getState().firebaseRealTime;
  const { companyId, shopId } = store.getState().user;
  const { isGeneralData, promoCode } = promotion
  const hasAccess = checkAccess('features', 'globalCodePromo')

  if (hasAccess && isGeneralData && shops) {
    for (const key of _.keys(shops)) {
      if (hasExternalIntegration(key) !== ZELTY) {
        sendPutRequest(
          API_UPDATE_PROMO(companyId, key, promoCode),
          promotion,
          { Authorization: `Bearer ${idToken}` }
        );
      }

    }
  } else {
    await sendPutRequest(
      API_UPDATE_PROMO(companyId, shopId, promoCode),
      promotion,
      { Authorization: `Bearer ${idToken}` }
    );
  }
};

export const updateSupportConfigForShop = async configurations => {
  const { support, managementFee, charges, cancelFee } = configurations
  await apiService.shopsUpsert(
    [getShopId()],
    { support, managementFee, cancelFee, configuration: { refs: { charges } } }
  )
}


export const updateDeliveryFee = async (data, isClient, shopIdIfNotAllShops) => {
  const baseUrl = ['delivery', isClient ? 'userServicePrice' : 'driverServicePrice']
  if (shopIdIfNotAllShops) {
    await apiService.shopsUpsert([shopIdIfNotAllShops, 'configuration', ...baseUrl], data)
  } else {
    await apiService.configurationUpsert(baseUrl, data)
  }
}

export const updateUserServicePrice = async shopIdIfNotAllShops => {
  if (shopIdIfNotAllShops) {
    await apiService.shopsUpsert([shopIdIfNotAllShops, 'configuration', 'delivery'], { userServicePrice: null })
  } else {
    await apiService.configurationUpsert(['delivery'], { userServicePrice: null })
  }
}

export const updateMethodTypeConfig = async configurations => {
  const {
    paymentTypes,
    orderTypes,
    orderTypesRef,
    paymentTypesRef,
    checkedDeliveryTypes,
    generalOrderTypes
  } = configurations;
  const { isAllShops, shopId, nbShops } = store.getState().user;
  const { isAdminOfThisShop } = await getUserPermissions(shopId);
  const type = orderTypes || paymentTypes;
  const methodType = orderTypes ? 'orderTypes' : 'paymentTypes';
  const typeRef = orderTypesRef || paymentTypesRef
  const newConfig = { terminal: {}, qrcode: {}, delivery: {} }

  if (isAllShops) {
    newConfig[methodType] = type['Commande à distance'];
    if (paymentTypes) {
      newConfig.terminal.paymentTypes = paymentTypes.Borne || null
      newConfig.qrcode.paymentTypes = paymentTypes[SUITABLE_TECHS.qrcode] || null
      newConfig.delivery.paymentTypes = checkedDeliveryTypes['Commande à distance'];
    }
  }
  else {
    const shopUpdates = { [methodType]: type['Commande à distance'] }
    if (orderTypes) {
      const newType = _.cloneDeep(type)
      shopUpdates?.orderTypes?.forEach(orderType => {
        if (!generalOrderTypes.includes(orderType)) {
          generalOrderTypes.push(orderType)
        }
      });

      newType['Commande à distance'] = generalOrderTypes
      newConfig[methodType] = updateOrderTypes(getShopId(), newType)
      if (!isAdminOfThisShop && nbShops === 1) {
        newConfig.orderTypes = shopUpdates.orderTypes
      }
    }
    if (paymentTypes) {
      newConfig.terminal.paymentTypes = paymentTypes.Borne || null
      newConfig.qrcode.paymentTypes = paymentTypes[SUITABLE_TECHS.qrcode] || null
      if (!isAdminOfThisShop && nbShops === 1) {
        newConfig.delivery.paymentTypes = checkedDeliveryTypes['Commande à distance']
      }
      if (!isAdminOfThisShop && !isAllShops) {
        shopUpdates.delivery = { paymentTypes: checkedDeliveryTypes['Commande à distance'] }
      }
    }
    if (hasExternalIntegration()) {
      shopUpdates.refs = { [methodType]: typeRef }
    }

    await apiService.shopsUpsert([getShopId(), 'configuration'], shopUpdates)
  }
  await apiService.configurationUpsert([], newConfig)
}

export const deleteCity = async cities => {
  try {
    await apiService.shopsUpsert([getShopId(), 'openCities'], cities, { updateMode: 'replace' })
  } catch (err) {
    console.log(err)
  }
}

export const addCity = async newCity => {
  try {
    const cityName = newCity.name.split(',')[0].replace(/\s+/g, '_');
    await apiService.shopsUpsert([getShopId(), 'openCities', cityName], newCity, { updateMode: 'replace' })
  } catch (err) {
    console.error('Error adding city:', err);
  }
}

export const updateDeliveryZone = async newZone => {
  await apiService.shopsUpsert([getShopId(), 'deliveryZones', newZone.key], newZone, { updateMode: 'replace' })
}

export const removeDeliveryZone = async (zone, deliverZones) => {
  const shopUpdates = {};
  _.map(deliverZones, ({ priority }, key) => {
    if (zone.key === key) shopUpdates[key] = null
    else if (priority > zone.priority) shopUpdates[key] = { priority: priority - 1 }
  })
  await apiService.shopsUpsert([getShopId(), 'deliveryZones'], shopUpdates)
};

export const createDistrict = async (newDistrict, city, isSubLocality) => {
  try {
    await apiService.shopsUpsert(
      [getShopId(), 'openCities', city.split(',')[0], isSubLocality ? 'subLocalities' : 'districts'],
      { [newDistrict.name.split(',')[0]]: newDistrict },
      { updateMode: 'merge' }
    )
  } catch (err) {
    console.error(err) // TODO DescriptiveError
  }
};

export const addSpecialHourToFirebase = async (specialHour, key) => {
  await apiService.shopsUpsert([getShopId(), 'specialHours', key], specialHour, { updateMode: 'replace' })
}

export const removeSpecialHourOnFirebase = async key => {
  await apiService.shopsDelete([getShopId(), 'specialHours', key])
}

export const synchroniseMenuData = async (shops) => {
  const { nbShops } = store.getState().user
  const synchronizeAll = _.size(shops) === nbShops
  if (checkAccess('features', 'globalProduct') && shops) {
    const idToken = await getIdToken();
    const { shopId } = store.getState().user;
    await sendPostRequest(
      API_SYNCHRONIZE_MENU,
      { shopId, shops, synchronizeAll, replace: false },
      { Authorization: `Bearer ${idToken}` }
    );
  }
};

export const updateShopData = async (legal, shop, configurations, chosenTechs) => {
  // TODO this should be done in backend
  const { address, email, name, number } = shop;
  const { keyWords, businessType } = configurations;
  const { webApp } = chosenTechs;
  legal.businessType = BUSINESS_TYPE_CODE[businessType]
  const updates = {
    configuration: { completed: { stripe: 'launching', firebase: true } },
    legal,
    address,
    name,
    support: { email, number },
  }
  if (webApp) {
    await apiService.configurationUpsert(['webapp'], { keywords: keyWords })
  }
  await apiService.shopsUpsert([getShopId()], updates)
  return true;
}